import { forwardRef } from "react"
import { css } from "@emotion/react"
import cx from "classnames"

type CurrencyInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  currencySymbol?: string
}

export const CurrencyInput = forwardRef<HTMLInputElement, CurrencyInputProps>(
  function CurrencyInput({ currencySymbol = "$", ...props }, ref) {
    return (
      <div className={cx("p-r", props.className)}>
        <span
          css={styles.symbol}
          style={{
            color: props.value ? "var(--color-tint1)" : "var(--color-tint4)",
          }}
          aria-hidden="true"
        >
          {currencySymbol}
        </span>
        <input
          type="text"
          placeholder="0"
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          inputMode="decimal"
          ref={ref}
          css={styles.input}
          {...props}
        />
      </div>
    )
  },
)

const styles = {
  symbol: css`
    position: absolute;
    line-height: 1;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    left: 0.75rem;
  `,
  input: css`
    text-align: right;

    &[type="text"] {
      padding-inline-start: 1.5rem;
    }
  `,
}
